import get from 'lodash.get';
import { Configuration } from 'store/configurations';
import { ConfigurationForm, CreateConfigurationForm } from './types';

/**
 * Generates the configuration form based on the current configuration.
 * If no configuration is provided, the fields are set to read-only with default values.
 */
export const getConfigurationForm = (configuration?: Configuration): ConfigurationForm => {
  const name = get(configuration, 'name', '');
  const primaryColor = get(configuration, 'configuration.globalSettings.palette.primary', '');
  const primaryFont = get(configuration, 'configuration.globalSettings.fonts.primary', '');
  const donationPopup = get(configuration, 'ticketing.donations.overlay.enabled', false);
  const lookup = get(configuration, 'ticketing.customerIdentification.lookup.enabled', false);
  const creation = get(configuration, 'ticketing.customerIdentification.creation.enabled', false);
  const surveyPage = get(configuration, 'ticketing.survey.enabled', false);

  return {
    name: {
      error: null,
      initialValue: name,
      propertyPath: 'name',
      readOnly: !configuration,
      shouldParse: false,
      value: name
    },
    primaryColor: {
      error: null,
      initialValue: primaryColor,
      propertyPath: 'configuration.globalSettings.palette.primary',
      readOnly: !configuration,
      shouldParse: false,
      value: primaryColor
    },
    primaryFont: {
      error: null,
      initialValue: primaryFont,
      propertyPath: 'configuration.globalSettings.fonts.primary',
      readOnly: !configuration,
      shouldParse: false,
      value: primaryFont
    },
    donationPopup: {
      error: null,
      initialValue: donationPopup,
      propertyPath: 'ticketing.donations.overlay.enabled',
      readOnly: !get(configuration, 'ticketing.donations.overlay'),
      shouldParse: false,
      value: donationPopup
    },
    lookup: {
      error: null,
      initialValue: lookup,
      propertyPath: 'ticketing.customerIdentification.lookup.enabled',
      readOnly: !get(configuration, 'ticketing.customerIdentification.lookup'),
      shouldParse: false,
      value: lookup
    },
    creation: {
      error: null,
      initialValue: creation,
      propertyPath: 'ticketing.customerIdentification.creation.enabled',
      readOnly: !get(configuration, 'ticketing.customerIdentification.creation'),
      shouldParse: false,
      value: creation
    },
    surveyPage: {
      error: null,
      initialValue: surveyPage,
      propertyPath: 'ticketing.survey.enabled',
      readOnly: !get(configuration, 'ticketing.survey'),
      shouldParse: false,
      value: surveyPage
    }
  };
};

/**
 * Generates the form used to create a new configuration.
 */
export const getCreateConfigurationForm = (): CreateConfigurationForm => ({
  name: {
    error: null,
    initialValue: '',
    propertyPath: 'name',
    readOnly: false,
    shouldParse: false,
    value: ''
  }
});
